import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="w-full py-8 mt-auto border-t border-cv-border bg-cv-page/80">
      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between text-sm text-cv-muted">
        <div className="mb-4 md:mb-0">
          Chronovela is operated by Skald Haven Inc.
        </div>
        <div className="flex flex-wrap items-center justify-center gap-6">
          <a href="/help" className="hover:text-cv-gold transition-colors font-bold text-cv-muted">Help Center</a>
          <a href="/terms" className="hover:text-cv-gold transition-colors">Terms of Service</a>
          <a href="/privacy" className="hover:text-cv-gold transition-colors">Privacy Policy</a>
          <a href="/refund-policy" className="hover:text-cv-gold transition-colors">Refund Policy</a>
          <a href="/ai-disclaimer" className="hover:text-cv-gold transition-colors">AI Content Disclaimer</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
